export const COOKIE_BRIDGE_EVENTS = {
  APP_MODAL_OPEN: "inito-cookie:app-modal-open",
  APP_MODAL_CLOSE: "inito-cookie:app-modal-close",
  BANNER_SHOWN: "inito-cookie:banner-shown",
  BANNER_HIDDEN: "inito-cookie:banner-hidden",
  MODAL_SHOWN: "inito-cookie:modal-shown",
  MODAL_HIDDEN: "inito-cookie:modal-hidden",
} as const;
